import React from 'react'

function AffiliateFooter() {
  return (
    <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col">
            <div className="d-flex align-items-center justify-content-center pt-2">
              <p className="text-muted text-sm mb-0">2024 - 2025 © Copyright Cloud ECS Infotech. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>
  )
}

export default AffiliateFooter